// extracted by mini-css-extract-plugin
export var content = "GenericPage-module--content--upzd4";
export var top = "GenericPage-module--top--tcv0O";
export var bottom = "GenericPage-module--bottom--e56CO";
export var left = "GenericPage-module--left--hU0eA";
export var right = "GenericPage-module--right--gRB3s";
export var small = "GenericPage-module--small--0yaIk";
export var medium = "GenericPage-module--medium--NVzZ0";
export var large = "GenericPage-module--large--zDe86";
export var legend = "GenericPage-module--legend--U1k5M";